package org.gstechnovos.jexonplastech.sections.home.styles

import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.gstechnovos.jexonplastech.theme.toSitePalette
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s

val CompanyOverviewContainerStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .fillMaxWidth()
            .backgroundColor(palette.custom.white)
    }
}

val StatCardStyle = CssStyle {
    val palette = colorMode.toSitePalette()
    base {
        Modifier
            .padding(24.px)
            .borderRadius(12.px)
            .backgroundColor(palette.custom.lightGray)
            .border(1.px, org.jetbrains.compose.web.css.LineStyle.Solid, palette.custom.divider)
            .transition(Transition.of("transform", 0.3.s), Transition.of("box-shadow", 0.3.s))
    }
    hover {
        Modifier
            .translateY((-4).px)
            .boxShadow(0.px, 10.px, 20.px, color=palette.custom.darkText.toRgb().copyf(alpha = 0.05f))
    }
}